import { definePlatformSetting } from '@crest/platform-contracts/settings';
import { z } from 'zod';
export const schedulingEventsCopyValueSchema = z.strictObject({
    navigationLabel: z.string().trim().min(1).max(60),
    title: z.string().trim().min(1).max(80),
    description: z.string().trim().min(1).max(240),
    emptyTitle: z.string().trim().min(1).max(120),
    emptyDescription: z.string().trim().min(1).max(240),
    loadingLabel: z.string().trim().min(1).max(120),
});
export const schedulingEventsCopySetting = definePlatformSetting({
    definition: {
        key: 'scheduling.copy.events',
        moduleId: 'scheduling',
        title: 'Schedule interface copy',
        helpText: 'Controls tenant-editable labels in the Scheduling calendar surfaces.',
        configurationDomain: 'copy',
        valueType: 'object',
        schemaVersion: 1,
        codedFallback: {
            navigationLabel: 'Schedule & Dispatch',
            title: 'Dispatch Board',
            description: 'Choose the workday, schedule job visits, and assign the crew doing the work.',
            emptyTitle: 'No work scheduled for this day',
            emptyDescription: 'Schedule an appointment or choose another date.',
            loadingLabel: 'Loading the dispatch board…',
        },
        permittedScopes: ['platform', 'plan', 'tenant'],
        mergeStrategy: 'deep-merge',
        clientSafe: true,
        serverOnly: false,
        sensitive: false,
        tenantEditable: true,
        userOverridable: false,
        offlineEligible: true,
        safetyClass: 'ordinary',
    },
    valueSchema: schedulingEventsCopyValueSchema,
});
export const schedulingCalendarCopyValueSchema = z.strictObject({
    viewLabel: z.string().trim().min(1).max(80),
    dispatchLabel: z.string().trim().min(1).max(60),
    monthLabel: z.string().trim().min(1).max(60),
    agendaLabel: z.string().trim().min(1).max(60),
    monthTitle: z.string().trim().min(1).max(80),
    agendaTitle: z.string().trim().min(1).max(80),
    description: z.string().trim().min(1).max(240),
    previousMonthAction: z.string().trim().min(1).max(80),
    nextMonthAction: z.string().trim().min(1).max(80),
    loadingLabel: z.string().trim().min(1).max(120),
    emptyDayLabel: z.string().trim().min(1).max(120),
    openDayAction: z.string().trim().min(1).max(80),
    showAllAction: z.string().trim().min(1).max(80),
    allDayLabel: z.string().trim().min(1).max(60),
    finishEditingLabel: z.string().trim().min(1).max(240),
});
export const schedulingCalendarCopyFallback = {
    viewLabel: 'Schedule view',
    dispatchLabel: 'Dispatch',
    monthLabel: 'Month',
    agendaLabel: 'Agenda',
    monthTitle: 'Calendar',
    agendaTitle: 'Schedule agenda',
    description: 'Appointments are shown on their start day in your device time zone. Open a day to dispatch or edit work.',
    previousMonthAction: 'Previous month',
    nextMonthAction: 'Next month',
    loadingLabel: 'Loading the complete calendar…',
    emptyDayLabel: 'No work scheduled',
    openDayAction: 'Open dispatch day',
    showAllAction: 'Show all appointments',
    allDayLabel: 'All day',
    finishEditingLabel: 'Save or cancel this appointment before changing the date, view, or another appointment.',
};
export const schedulingCalendarCopySetting = definePlatformSetting({
    definition: {
        key: 'scheduling.copy.calendar',
        moduleId: 'scheduling',
        title: 'Calendar interface copy',
        helpText: 'Controls labels for the month and agenda views without changing saved Dispatch copy.',
        configurationDomain: 'copy',
        valueType: 'object',
        schemaVersion: 1,
        codedFallback: schedulingCalendarCopyFallback,
        permittedScopes: ['platform', 'plan', 'tenant'],
        mergeStrategy: 'deep-merge',
        clientSafe: true,
        serverOnly: false,
        sensitive: false,
        tenantEditable: true,
        userOverridable: false,
        offlineEligible: true,
        safetyClass: 'ordinary',
    },
    valueSchema: schedulingCalendarCopyValueSchema,
});
export const schedulingSettingRegistrations = [schedulingEventsCopySetting, schedulingCalendarCopySetting];
//# sourceMappingURL=scheduling-setting-definitions.js.map